import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasProduct, ProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ExplodedViewItemsComponent from "@store/Components/ExplodedView/ExplodedViewItems";
import { StorePdpState } from "@store/Store/Reducers/PdpReducer";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    displayAsTable = "displayAsTable",
}

const mapStateToProps = (state: StorePdpState) => ({
    products: getProductsForProductInfoList(state, "explodedViewItems"),
});

const mapDispatchToProps = {
    loadCarouselProducts,
};

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SubAssemblyItemsStyles {
    wrapper?: InjectableCss;
}

export const specificationsStyles: SubAssemblyItemsStyles = {
    wrapper: {
        css: css`
            margin-top: 20px;
        `,
    },
};

const styles = specificationsStyles;

const ExplodedViewItems: React.FC<Props> = ({
    product,
    fields: { displayAsTable },
    products,
    loadCarouselProducts,
}) => {
    const productContext = React.useContext(ProductContext);
    const brandContext = React.useContext(BrandStateContext).value;
    const category = React.useContext(CategoryContext);

    React.useEffect(() => {
        loadCarouselProducts({
            carouselId: "explodedViewItems",
            carouselType: "relatedProducts",
            relatedProductType: "ExplodedViewProduct",
            seedWithManuallyAssigned: "",
            displayProductsFrom: "allCategories",
            selectedCategoryIds: [],
            numberOfProductsToDisplay: 99,
            isProductDetailsPage: true,
            productId: productContext?.product?.id,
            isProductListPage: false,
            category,
            isBrandDetailsPage: false,
            brand: brandContext,
        });
    }, [productContext?.product?.id]);

    if (!products || !product) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <ExplodedViewItemsComponent product={product} displayAsTable={displayAsTable} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps, mapDispatchToProps)(ExplodedViewItems)),
    definition: {
        displayName: "Exploded View Items",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.displayAsTable,
                displayName: "Display As Table",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
